import React from 'react';
import _omit from 'lodash/omit';
import { MultiSelect } from 'ui/selectv2/MultiSelect';
import { FlexSpacer } from 'ui/flexSpacer';
import { GhostButton, SecondaryButton, PrimaryButton } from 'ui/button';
import { PageHeader } from 'ui/pageHeader';
import { DefineFieldTypes } from './DefineFieldTypes';
import { MODE, MESSAGE_ACTION_COPY, FIELD_TYPES_FILTER_OPTIONS } from '../constants';
import {
  showMessage,
  getMessageContent,
  getHandleCancelState,
  getHandleEnterConfirmMode,
  getHandleEnterDefineModeState,
} from './FieldTypes.utils';

import {
  FieldTypeContainer,
  MessageContainer,
  StyledWarningBanner,
  MultiSelectContainer,
} from './FieldTypes.styled';

// type Props = {
//   breadcrumbs: Object,
//   canManageCatalogs: Boolean,
//   rows: Array<Object>,
//   catalogName: string,
//   undefinedFields: Array<Object>,
//   fetchCatalogFieldTypesRequest: (*) => void,
//   updateAndFetchFieldTypes: (*) => void,
// };

// type State = {
//   fields: Object,
//   viewMode: string,
//   filterFields: Array<*>,
//   suggestedTypes: Object,
// };

class CatalogFieldTypes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {},
      filterFields: FIELD_TYPES_FILTER_OPTIONS,
      viewMode: MODE.view,
      suggestedTypes: {},
    };
  }

  showMessage = () => showMessage(this.props);

  messageContent = () => getMessageContent(this.props, this.state);

  messageActionText = () => {
    const { viewMode } = this.state;
    switch (viewMode) {
      case MODE.view:
      case MODE.define:
      case MODE.confirm:
        return MESSAGE_ACTION_COPY[viewMode];
      default:
        return '';
    }
  };

  handleEnterDefineMode = () => {
    const stateToSet = getHandleEnterDefineModeState(this.props, this.state);
    this.setState(stateToSet);
  };

  handleCancel = () => {
    this.setState(getHandleCancelState());
  };

  handleEnterConfirmMode = () => {
    this.setState(getHandleEnterConfirmMode());
  };

  handleSave = () => {
    const { catalogName, updateAndFetchFieldTypes } = this.props;
    const { fields } = this.state;
    // call save here
    updateAndFetchFieldTypes(catalogName, fields);
    this.setState({ viewMode: MODE.view, fields: {} });
  };

  footerContent = () => {
    const { viewMode, fields } = this.state;
    const { undefinedFields } = this.props;
    const numDefined = Object.keys(fields).length;
    const numUndefined = undefinedFields.length - numDefined;
    return viewMode === MODE.define ? (
      <span>
        Changes will be made to <strong>{numDefined}</strong> fields in this catalog
        {numUndefined > 0 && `, with ${numUndefined} fields remaining undefined`}
      </span>
    ) : (
      <span>
        <strong>Be careful!</strong> Once defined, field types cannot be redefined.
      </span>
    );
  };

  getDefineModeAction = () => {
    const { viewMode } = this.state;
    return viewMode === MODE.define ? this.handleCancel() : this.handleEnterDefineMode();
  };

  footerActionText = () => {
    const { viewMode } = this.state;
    return viewMode === MODE.define ? 'Skip for now' : 'Go back';
  };

  dropdownOnChangeHandler = (val, fieldName) => {
    const { fields } = this.state;
    if (val) {
      this.setState({ fields: { ...fields, [fieldName]: val } });
    } else {
      this.setState({ fields: _omit(fields, fieldName) });
    }
  };

  handleFilterClick = (filterFields) => {
    this.setState({ filterFields });
  };

  renderFilter = () => {
    const { filterFields, viewMode } = this.state;

    return viewMode === MODE.view ? (
      <MultiSelectContainer data-test="field-types-filter-container">
        <MultiSelect
          compactCutoff={4}
          placeholder="Filter Field Types"
          onSelect={this.handleFilterClick}
          options={FIELD_TYPES_FILTER_OPTIONS}
          value={filterFields}
        />
      </MultiSelectContainer>
    ) : null;
  };

  filterTableRows = () => {
    const { filterFields } = this.state;
    const { rows } = this.props;
    const filterValues = filterFields.map((filterType) => filterType.value);
    const filteredRows = rows.filter((row) => filterValues.includes(row.fieldType));
    return filteredRows.map((row, i) => {
      return {
        ...row,
        id: i,
      };
    });
  };

  render() {
    const { breadcrumbs, canManageCatalogs, catalogName, undefinedFields } = this.props;
    const { viewMode, fields } = this.state;

    return (
      <FieldTypeContainer>
        <PageHeader
          breadcrumb={breadcrumbs}
          pageActions={
            <>
              {this.showMessage() ? (
                <StyledWarningBanner
                  BannerActions={
                    <GhostButton isDisabled={!canManageCatalogs} onClick={this.getDefineModeAction}>
                      {this.messageActionText()}
                    </GhostButton>
                  }
                >
                  <MessageContainer>
                    <span>{this.messageContent()}</span>
                  </MessageContainer>
                </StyledWarningBanner>
              ) : null}
              {this.renderFilter()}
            </>
          }
        >
          Field definitions for {catalogName}
        </PageHeader>

        <DefineFieldTypes
          dropdownOnChangeHandler={this.dropdownOnChangeHandler}
          viewMode={viewMode}
          fields={fields}
          undefinedFields={undefinedFields}
          rows={this.filterTableRows()}
        />
        {viewMode !== MODE.view && (
          <StyledWarningBanner
            BannerActions={
              <FlexSpacer justifyContent="flex-end">
                <GhostButton onClick={this.getDefineModeAction}>
                  {this.footerActionText()}
                </GhostButton>
                {viewMode === MODE.define ? (
                  <SecondaryButton onClick={this.handleEnterConfirmMode}>
                    Review these changes
                  </SecondaryButton>
                ) : (
                  <PrimaryButton onClick={this.handleSave}>Confirm save</PrimaryButton>
                )}
              </FlexSpacer>
            }
          >
            <MessageContainer>
              <div>{this.footerContent()}</div>
            </MessageContainer>
          </StyledWarningBanner>
        )}
      </FieldTypeContainer>
    );
  }
}

CatalogFieldTypes.defaultProps = {
  breadcrumbs: {},
  rows: [],
  undefinedFields: [],
};

export default CatalogFieldTypes;
